import { cssJoin } from '@volvo-cars/css/utils';

const ThumbButton: React.FC<{
  disabled: boolean;
  selected: boolean;
  direction?: 'up' | 'down';
  onClick: () => void;
}> = ({ disabled, selected, direction = 'up', onClick }) => (
  <button
    type="button"
    className={cssJoin(`${direction === 'down' && 'rotate-180'}`, 'h-48')}
    onClick={onClick}
    disabled={disabled}
    aria-label={`Thumb ${direction} ${selected ? 'selected' : 'deselected'}`}
    style={{ opacity: disabled ? 0.5 : 1 }}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 47 47"
      width="48"
      height="48"
      fill="none"
    >
      {selected && <circle cx="23.5" cy="23.5" r="23.5" fill="#284E80" />}
      <path
        fill={selected ? '#FFF' : '#707070'}
        fillRule="evenodd"
        d="M23.43 1a22.42 22.42 0 1 0 0 44.85 22.42 22.42 0 0 0 0-44.85Zm0 43.13a20.7 20.7 0 1 1 0-41.4 20.7 20.7 0 0 1 0 41.4ZM13.07 33.77h-1.72V17.4h1.72v16.38Zm18.18-15.52h-6.9c.76-1.93 1.2-3.97 1.3-6.04 0-2.87-3.23-4.15-3.23-4.15s-1.69 10.19-6.77 10.19v13.54A43.67 43.67 0 0 0 30 34.02c1.5 0 2.47-1.42 3.5-4.84A35.12 35.12 0 0 0 34.79 21c.12-1.73-.43-2.75-3.52-2.75h-.01Zm1.74 3.26.05-.67c.03-.2.03-.4.01-.6a3.45 3.45 0 0 0-1.78-.26h-9.5l.95-2.4a17.18 17.18 0 0 0 1.17-5.4c0-.43-.15-.85-.4-1.2-.85 3.02-2.69 7.55-6.14 8.71v10.87a44.85 44.85 0 0 0 12.61 1.72c.23 0 .87-.35 1.86-3.61a31.05 31.05 0 0 0 1.17-7.16Z"
      />
    </svg>
  </button>
);

export default ThumbButton;
